var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9453 13.2341C24.9453 19.8615 19.5727 25.2341 12.9453 25.2341C6.31789 25.2341 0.945312 19.8615 0.945312 13.2341C0.945312 6.60671 6.3179 1.23413 12.9453 1.23413C19.5727 1.23413 24.9453 6.60671 24.9453 13.2341Z",
    stroke: "#E09944"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9453 19.7341C16.5352 19.7341 19.4453 16.824 19.4453 13.2341C19.4453 9.64428 16.5352 6.73413 12.9453 6.73413C9.35546 6.73413 6.44531 9.64428 6.44531 13.2341C6.44531 16.824 9.35546 19.7341 12.9453 19.7341Z",
    fill: "#E09944"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRadio);
export default __webpack_public_path__ + "static/media/check-radio.1c6f9e28726fde49afb49bfa26a0c72b.svg";
export { ForwardRef as ReactComponent };